import { Signal } from "signals";

class KeyInput {
    public keyup: Signal = new Signal();

    constructor() {
        window.onkeyup = (e: any) => {
            const key = e.keyCode ? e.keyCode : e.which;

            this.keyup.dispatch(key, e);
        };
    }
}

export default new KeyInput();
